import { SplitTestState } from '../../types.js';
export const splitTestsSections = [
    {
        title: 'Overrides',
        description: 'These are your personal split tests overrides. ' +
            'You have specifically selected these through the Internal Tools panel.',
        emptyMessage: 'No overridden split tests',
        filter: (splitTest, overrides) => splitTest.variations.some(variation => overrides.includes(variation.id)),
        tests: [],
    },
    {
        title: 'Defaults',
        description: 'These split tests have a default internal variation and are currently active. ' +
            'These tests are applied to the page that you are currently viewing (not on development).',
        emptyMessage: 'No default split tests',
        filter: (splitTest) => !!splitTest.defaultInternalVariation &&
            [SplitTestState.LIVE, SplitTestState.ACTIVE, SplitTestState.RUNNING].includes(splitTest.state),
        tests: [],
    },
    {
        title: 'Other',
        description: 'These split tests are not applied to the page that you are viewing.',
        emptyMessage: 'No other split tests',
        filter: () => true,
        tests: [],
    },
];
//# sourceMappingURL=splitTestsSections.js.map